import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LocalStorageService} from 'ngx-webstorage';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class AuthService {

  private serverUrl = environment.serverUrl;

  constructor(private http: HttpClient,
              private localSt: LocalStorageService) {}

  logIn(data): Observable<any> {
    return this.http.post(this.serverUrl + 'customers/login', data);
  }

  logOut(): Observable<any> {
    return this.http.post(this.serverUrl + 'customers/logout', {}, {
      headers: new HttpHeaders().set('Authorization', this.localSt.retrieve('zenUser').token)
    });
  }

  forgotPwd(data): Observable<any> {
    return this.http.post(this.serverUrl + 'customers/forgotpassword', data);
  }

  resetPwd(data): Observable<any> {
    return this.http.put(this.serverUrl + 'customers/resetpassword', data);
  }
  changePwd(data): Observable<any> {
    return this.http.put(this.serverUrl + 'customers/changepassword', data);
  }

  signup(data): Observable<any> {
    return this.http.post(this.serverUrl + 'customers', data);
  }

  updateProfile(data): Observable<any> {
    return this.http.put(this.serverUrl + 'customers', data);
  }

  uploadProfileImage(data): Observable<any> {
    const boundary = Math.random().toString().substr(2);
    const headers = new HttpHeaders();
          headers.append('content-type',
         'multipart/form-data; charset=utf-8; boundary=' + boundary);
    return this.http.post(this.serverUrl + 'customers/uploadimage', data, {headers: headers });
  }

  getProfileDetails(): Observable<any> {
    return this.http.get(this.serverUrl + 'customers/myprofile');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts